// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabelStyle":"Checkbox_checkboxLabelStyle__2hqC6","checkboxStyle":"Checkbox_checkboxStyle__CCfoM"};